<template>
  <div>
    <div style="margin: 15px 0 0 18px"><span style="font-size: 18px;">个人信息</span></div>
    <div class="fill_form mt20 m0 mb30 clearfix" >
      <div class="fill_group_row clearfix fl w_half">

        <div class="form_group clearfix">
          <label class="control_label "><em>*</em>姓名</label>
          <div class="form_control w_auto ">
            <spn class="line_h36">{{infoList.username}}</spn>
          </div>
        </div>
        <div class="form_group clearfix">
          <label class="control_label ">手机号</label>
          <div class="form_control w_auto ">
            <span class="line_h36">{{infoList.mobile}}</span>
            <span class="color_blue line_h36 ml20" @click="changeMobile" style="cursor: pointer;">
              更改手机号
            </span>
          </div>
        </div>
        <div class="form_group clearfix">
          <label class="control_label ">密码</label>
          <div class="form_control w_auto ">
            <span class="color_blue line_h36" @click="changePassword" style="cursor: pointer;">更改密码</span>
          </div>
        </div>
      </div>
      <div class="fill_group_row clearfix fr w_half">

        <div class="form_group clearfix">
          <label class="control_label "><em>*</em>居民身份证</label>
          <div class="form_control w_auto ">
            <spn class="line_h36">{{infoList.idcard}}</spn>
          </div>
        </div>
        <div class="form_group clearfix">
          <label class="control_label "><em>*</em>负责单位</label>
          <div class="form_control w_auto ">
            <spn class="line_h36">{{infoList.company_name}}</spn>
          </div>
        </div>
      </div>
    </div>
    <msgTips v-show="showFlag" @confirm="toChangePassword" @cancel="closeLayer" mheight="220" title="修改密码">
      <div class="login" style="height: 37%;">
        <div class="center_box t-10" style="height: 130px;">
          <div class="login_min mt0">
            <vue-form :state="formstate" id="loginForm">
              <validate tag="div" class="p_rel clearfix">
                <p class="fl hl50 i_w100">旧密码</p>
                <div class="fr p_rel">
                  <input class="i_w250 form_input" id="user_name" v-model="params.pre_password" type="password"
                         style="height: 30px;"
                         name="pre_password" placeholder="" required pattern="^\d{6}$">
                  <field-messages name="pre_password" show="$dirty || $touched || $submitted">
                    <div slot="required" class="errorMessage">旧密码不能为空</div>
                    <div slot="pattern" class="errorMessage">请填写6位数字密码</div>
                  </field-messages>
                </div>

              </validate>
              <validate tag="div" class="p_rel clearfix">
                <p class="fl hl50 i_w100">新密码</p>
                <div class="fr p_rel">
                  <input class="i_w250 form_input" v-model="params.new_password" type="password"
                         style="height: 30px;"
                         name="new_password" placeholder="" required pattern="^\d{6}$">
                  <field-messages name="new_password" show="$dirty || $touched || $submitted">
                    <div slot="required" class="errorMessage">新密码不能为空</div>
                    <div slot="pattern" class="errorMessage">请填写6位数字密码</div>
                  </field-messages>
                </div>

              </validate>
            </vue-form>
          </div>
        </div>
      </div>
    </msgTips>
    <msgTips v-show="showFlag1" @confirm="toChangePhone" @cancel="closeLayer1" mheight="320" title="修改手机号">
      <div class="login" style="height: 52%;">
        <div class="center_box t-10" style="height: 200px;">
          <div class="login_min mt0">
            <vue-form :state="formstate1">
              <validate tag="div" class="p_rel clearfix">
                <p class="fl hl50 i_w100">当前账户密码</p>
                <div class="fr p_rel">
                  <input class="i_w250 form_input" v-model="params1.pre_password" type="password" name="newPassword"
                         style="height: 30px;"
                         placeholder="" required pattern="^\d{6}$">
                  <field-messages name="newPassword" show="$dirty || $touched || $submitted">
                    <div slot="required" class="errorMessage">密码不能为空</div>
                    <div slot="pattern" class="errorMessage">请填写6位数字密码</div>
                  </field-messages>
                </div>

              </validate>
              <validate tag="div" class="p_rel clearfix">
                <p class="fl hl50 i_w100">新手机号</p>
                <div class="fr p_rel">
                  <input id="password" class="form_input i_w250" type="text" v-model="params1.new_mobile" name="new_mobile"
                         style="height: 30px;"
                         placeholder="" required pattern="^[1][0-9]{10}$">
                  <field-messages name="new_mobile" show="$dirty || $touched || $submitted">
                    <div slot="required" class="errorMessage">手机号不能为空</div>
                    <div slot="pattern" class="errorMessage">请填写正确的手机号</div>
                  </field-messages>
                </div>
              </validate>
              <validate tag="div" class="p_rel clearfix">
                <p class="fl hl50 i_w100">验证码</p>
                <div class="fr p_rel clearfix">
                  <input class="pass_word i_w130 fl mr20" type="text" v-model="params1.code" name="shotCode"
                         style="height: 30px;"
                         placeholder="" required pattern="^\d{6}$">
                  <input class="pass_word i_w80 fr" :class="{can_login:!smsBtnDisabled}" @click="getSmsCode"
                         style="height: 30px;"
                         type="button" :disabled="smsBtnDisabled" :value="smsBtnTxt">
                  <field-messages name="shotCode" show="$dirty || $touched || $submitted">
                    <div slot="required" class="errorMessage">手机验证码不能为空</div>
                    <div slot="pattern" class="errorMessage">请填写正确的手机验证码</div>
                  </field-messages>
                </div>

              </validate>
            </vue-form>
          </div>
        </div>
      </div>
    </msgTips>
    <toastTips :content="toastContent" :is-show="toast"></toastTips>
  </div>
</template>
<script>
  import axios from 'axios'
  import qs from 'qs'
  import msgTips from '../layer/msgTips'
  import toastTips from '../layer/toastTips'
  export default{
    name:"personalInfo",
    components:{
      msgTips,
      toastTips
    },
    data(){
      return {
        infoList:{},
        showFlag:false,
        showFlag1:false,
        params:{
          pre_password:'',
          new_password:''
        },
        params1:{
          pre_password:'',
          new_mobile:'',
          code:''
        },
        formstate:{},
        formstate1:{},
        disabled:false,
        toast:false,
        toastContent:'',
        smsBtnTxt:'点击获取',
        smsBtnDisabled:false
      }
    },
    mounted:function(){
      axios.get('/admin/getInfo',{

      }).then((response)=>{
        if(response.data.code==22000){
          this.infoList=response.data.result
        }
      })
    },
    methods:{
      changePassword:function(){
        this.showFlag=true;
      },
      closeLayer:function(){
        this.showFlag=false;
      },
      toChangePassword:function(){
        if(!this.formstate.$invalid) {
          axios.post('/admin/updatePassword ',qs.stringify(
            this.params
          )).then((response)=>{
            var that = this;
            if(response.data.code==22000){
              that.showFlag=false;
              window.location.href='/#/login';
            }else if(response.data.code==50001){
              window.location.href='/#/login';
            }else{
              that.toast=true;
              that.toastContent=response.data.message;
              setTimeout(function(){
                that.toast=false;
                that.toastContent='';
              },3000)
            }
          })
        }else{
          this.formstate._submit();
        }

      },
      changeMobile:function(){
        this.showFlag1=true;
      },
      closeLayer1:function(){
        this.showFlag1=false;
      },
      getSmsCode:function(){
        this.smsBtnDisabled=true;
        axios.post('/login/sendSms',qs.stringify(
          {
            mobile:this.params1.new_mobile,
            type:'reset'
          }
        )).then((response)=>{
          var that=this;
          console.log(response);
          if(response.data.code == 22000){
            let num = 120;
            let timer = setInterval(function(){
              if(num!=0){
                num--;
                that.smsBtnTxt=num+'秒后重发';
              }else{
                num=120;
                that.smsBtnTxt='点击获取';
                that.smsBtnDisabled=false;
                clearInterval(timer);
              }

            },1000);
          }else if(response.data.code==50001){
            window.location.href='/#/login';
          }else{
            that.toast=true;
            this.smsBtnDisabled=false;
            that.toastContent=response.data.message;
            setTimeout(function(){
              that.toast=false;
              that.toastContent='';
            },3000)
          }
        })
      },
      toChangePhone:function(){
        var that=this;
        if(!this.formstate1.$invalid) {
          axios.post('/admin/updateMobile',qs.stringify(
            this.params1
          )).then((response)=>{
            if(response.data.code == 22000){
              that.toast=true;
              that.toastContent=response.data.message;
              setTimeout(function(){
                that.toast=false;
                that.toastContent='';
              },3000);
              window.location.reload();
            }else if(response.data.code==50001){
              window.location.href='/#/login';
            }else{
              that.toast=true;
              that.toastContent=response.data.message;
              setTimeout(function(){
                that.toast=false;
                that.toastContent='';
              },3000)
            }
          })
        }else{
          this.formstate1._submit();
        }

      }
    }
  }
</script>
<style lang="less" scoped>
  .i_w250{
    width: 250px!important;
  }
  .hl50{
    height: 50px;
    line-height: 50px !important;
  }
  .center_box{
    width: 360px!important;
    margin-left: -180px!important;
  }
  .i_w130{
    width:130px!important;
  }
  .i_w80{
    width: 80px!important;
  }
  .i_w100{
    width:100px;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/personal_center/personalInfo.vue